import React from 'react';
import photo from '../../assets/salaaosol.jpg';
import './ImagemQuintaSection.css';

function ImagemQuintaSection() {
    return (
        <section className="imagem-quinta-section">
            <img
                src={photo}
                alt="Marquee"
                className="imagem-quinta"
                loading="lazy"
            />
        </section>
    );
}

export default ImagemQuintaSection;
